/*
*###############################################################################
*Module Name                   : WMSBinMasterContent.js                        #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Thursday, Novermber 30th 2023, 10:14:01 am    #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPDropDown from 'framework/components/DPDropDown'

const WMSBinMasterContent = ({
    binId,
    binIdOnChange,
    binIdOnBlur,
    searchdisabled,
    tog_xlarge,
    binZone,
    binZoneOnChange,
    binAisle,
    binAisleOnChange,
    binAisleOnBlur,
    binRack,
    binRackOnChange,
    binRackOnBlur,
    binBay,
    binBayOnChange,
    binBayOnBlur,
    binLevel,
    binLevelOnChange,
    binLevelOnBlur,
    IsActive,
    switchOnChange,
    disabled,
    menuName,
    menuCode,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    show,
    AlertMsg,
    AlertColor,
    ErrorMsg,
    zoneList,
    capacity,
    capacityOnChange,
    capacityOnBlur
}) => {

    const [HeadColumns, setHeadColumns] = useState([])
    const [groupFilter, SetGroupFilter] = useState("a")

    const ApiURL = window.Links.ApiURL

    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    async function tog_backdrop() {
        modelTrigger();
    }

    return (
        <React.Fragment>
            <div>
                <Row>
                    <Col sm="12">
                        <CardText className='mb-0'>
                            <Row>
                                {show ? (
                                    <Alert color={AlertColor} role="alert">
                                        {AlertMsg}
                                        <br />
                                        <small>{ErrorMsg}</small>
                                    </Alert>
                                ) : null}
                                <Col sm={12} md={6} className="mb-4-sm">
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Bin ID *"
                                        textType="text"
                                        maxLength="13"
                                        value={binId}
                                        onChange={binIdOnChange}
                                        onBlur={binIdOnBlur}
                                        disabled={disabled}
                                    />
                                    <DPDropDown
                                        optionGroup={zoneList}
                                        selectedGroup={binZone}
                                        rowClass="mb-4-sm"
                                        labelText="Bin Zone *"
                                        onChange={binZoneOnChange}

                                        disabled={disabled}

                                    />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Bin Aisle *"
                                        textType="text"
                                        maxLength="2"
                                        value={binAisle}
                                        onChange={binAisleOnChange}
                                        onBlur={binAisleOnBlur}
                                        disabled={disabled}
                                    />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Bin Rack *"
                                        textType="text"
                                        maxLength="2"
                                        value={binRack}
                                        onChange={binRackOnChange}
                                        onBlur={binRackOnBlur}
                                        disabled={disabled}
                                    />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Bin Bay *"
                                        textType="text"
                                        maxLength="2"
                                        value={binBay}
                                        onChange={binBayOnChange}
                                        onBlur={binBayOnBlur}
                                        disabled={disabled}
                                    />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Bin Level *"
                                        textType="text"
                                        maxLength="2"
                                        value={binLevel}
                                        onChange={binLevelOnChange}
                                        onBlur={binLevelOnBlur}
                                        disabled={disabled}
                                    />
                                    <DPTextBox
                                        rowClass="mb-4-sm"
                                        labelText="Capacity "
                                        textType="text"
                                        maxLength="2"
                                        textAlign={"right"}
                                        value={capacity}
                                        onChange={capacityOnChange}
                                        onBlur={capacityOnBlur}
                                        disabled={disabled}
                                    />
                                    <Row>
                                        <Col sm={3}>
                                            <Label
                                                htmlFor="example-text-input"
                                                className={`col-md-12 col-form-label-sm`}
                                            >
                                                Active
                                            </Label>
                                        </Col>
                                        <Col >
                                            <DPSwitch
                                                rowClass={"mb-4-sm"}
                                                checked={IsActive}
                                                onChange={switchOnChange}
                                                disabled={disabled}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Button
                                        onClick={() => {
                                            tog_xlarge()
                                        }}
                                        color="success"
                                        className="btn-sm"
                                        disabled={searchdisabled}
                                    >
                                        <i
                                            className="mdi mdi-search-web"
                                            style={{ fontSize: "12px" }}
                                        ></i>
                                    </Button>
                                </Col>
                                <DPSearchBoxDynamic
                                    searchData={[]}
                                    columns={HeadColumns}
                                    defaultSorted={defaultSorted}
                                    mainTitle={menuName + " Search"}
                                    SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                    isOpen={modelOpen}
                                    toggle={modelTrigger}
                                    getSelect={GetSelectRow}
                                    APIURL={ApiURL}
                                    URLPath={"WMSBIN"}
                                    MenuCode={menuCode}
                                    KeyVal={"BIN"}
                                    searchBy={"BIN_ID"}
                                    FilterStr={groupFilter}
                                />
                            </Row>
                        </CardText>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default WMSBinMasterContent